import React, { useEffect, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import cn from 'src/taskpane/utility/bem';
import { TextField } from '@fluentui/react';
import { CmicContext } from 'src/taskpane/context/CmicContext';
import { handleTextTheme } from 'src/taskpane/shared/styles';
import Button from 'src/taskpane/shared/Button';
import './styles.scss';


const className = cn('enterprise-login');
const el = (name, mod) => cn(className, name, mod);

const EnterpriseLogin = ({
    ActionRoleContainer,
    URLLabel,
    URLVal,
    URLError,
    handleEnterpriseUrlSubmit,
    handleOnFocus,
    handleOnURLBlur,
    handleRoleChange,
    handleURLValueChange,
    isURLValid,
    textInputStyles,
    handleGoToBasicAuth
}) => {
    const inputRef = useRef(null);
    const { currentOfficeTheme } = useContext(CmicContext);
    const text_theme = handleTextTheme({ themeId: currentOfficeTheme.themeId });

    // auto focus
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    // Submit form on enter key pressed
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Enter') {
                handleEnterpriseUrlSubmit();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleEnterpriseUrlSubmit]);

    return (
        <div className={className}>
            <div className={el('content')}>
                <div className={el('header')}>
                    Are you an&nbsp;<div className={el('link')}>Enterprise</div>&nbsp;customer?
                </div>
                <div className={el('description')}>
                    Enterprise customers enter a URL with their Username and Password to sign in.
                </div>

                <ActionRoleContainer />

                <TextField
                    id="EnvironmentURL"
                    componentRef={inputRef}
                    className={`${el('input')} ${text_theme} ${URLError ? 'error' : ''}`}
                    value={URLVal}
                    placeholder={URLLabel}
                    onChange={handleURLValueChange}
                    onBlur={handleOnURLBlur}
                    onFocus={handleOnFocus}
                    errorMessage={URLError}
                    invalid={!isURLValid}
                    styles={textInputStyles}
                    aria-label={URLLabel}
                    autoComplete="off"
                    aria-required
                />

                <Button text="Proceed With OAuth 2.0" onClick={handleEnterpriseUrlSubmit} customStyles={{ marginBottom: '16px' }} />

                <div className={el('link-button')} onClick={handleGoToBasicAuth}>
                    This is a Basic Auth protected system
                </div>
            </div>

            <div className={el('footer')}>
                <Button
                    customClasses={el('button')}
                    variant="secondary"
                    text="No, I'm not an Enterprise Customer"
                    onClick={handleRoleChange}
                />
            </div>
        </div>
    );
};

export default EnterpriseLogin;

EnterpriseLogin.propTypes = {
    ActionRoleContainer: PropTypes.elementType.isRequired,
    URLLabel: PropTypes.string.isRequired,
    URLVal: PropTypes.string,
    URLError: PropTypes.string,
    handleEnterpriseUrlSubmit: PropTypes.func.isRequired,
    handleOnFocus: PropTypes.func,
    handleOnURLBlur: PropTypes.func.isRequired,
    handleRoleChange: PropTypes.func.isRequired,
    handleURLValueChange: PropTypes.func.isRequired,
    isURLValid: PropTypes.bool.isRequired,
    textInputStyles: PropTypes.func,
    handleGoToBasicAuth: PropTypes.func,
};